import React, { useEffect } from 'react';
import { Config } from '@retro-ui/config';

import AppLoader from '@f/components/shared/app-loader/AppLoader';

import { ConfigContext } from './ConfigContext';
import { fetchConfig } from './helpers/fetchConfig';

type ConfigProviderProps = {
  children: React.ReactNode;
  onConfigReady?: (config: Config['global']) => void;
};

export function ConfigProvider(props: ConfigProviderProps) {
  const { children, onConfigReady } = props;

  const [isLoading, setIsLoading] = React.useState(true);
  const [config, setConfig] = React.useState<Config['global'] | undefined>(undefined);

  useEffect(() => {
    const fetchConfigData = async () => {
      setIsLoading(true);
      const configData = await fetchConfig();
      setConfig(configData);
      setIsLoading(false);
      if (onConfigReady) {
        onConfigReady(configData);
      }
    };

    fetchConfigData();
  }, []);

  if (isLoading) {
    return <AppLoader />;
  }

  return <ConfigContext.Provider value={{ config }}>{children}</ConfigContext.Provider>;
}
